export default function getLookUp<T extends object, U extends keyof T>(arr: T[], key: U): { [k: string]: string } {
  return Array.from(new Set(arr.map(mail => mail[key]))).reduce(
    (acc, cur) => (typeof cur === 'string' ? { ...acc, [cur]: cur } : { ...acc }),
    {},
  );
}
